import validate from "/opt/build/repo/node_modules/.pnpm/nuxt@3.17.7_patch_hash=5f3b8151d137a290a56d4b64afb762fd6c769ab141252d2bddea4da6f9609c60_2a26b18e6557fd928546f9ac348aa5d1/node_modules/nuxt/dist/pages/runtime/validate.js";
import header_45global from "/opt/build/repo/domains/core/middleware/header.global.ts";
import i18n_45global from "/opt/build/repo/domains/core/middleware/i18n.global.ts";
import optimizely_45scroll_45global from "/opt/build/repo/domains/core/middleware/optimizelyScroll.global.ts";
import auto_45promo_45code_45global from "/opt/build/repo/domains/commerce/middleware/autoPromoCode.global.ts";
import dialogs_45global from "/opt/build/repo/domains/commerce/middleware/dialogs.global.ts";
import seo_45meta_45global from "/opt/build/repo/domains/commerce/middleware/seoMeta.global.ts";
import sierra_45chat_45page_45class_45global from "/opt/build/repo/domains/commerce/middleware/sierraChatPageClass.global.ts";
import preserve_45query_45global from "/opt/build/repo/domains/content/middleware/preserveQuery.global.ts";
import manifest_45route_45rule from "/opt/build/repo/node_modules/.pnpm/nuxt@3.17.7_patch_hash=5f3b8151d137a290a56d4b64afb762fd6c769ab141252d2bddea4da6f9609c60_2a26b18e6557fd928546f9ac348aa5d1/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  header_45global,
  i18n_45global,
  optimizely_45scroll_45global,
  auto_45promo_45code_45global,
  dialogs_45global,
  seo_45meta_45global,
  sierra_45chat_45page_45class_45global,
  preserve_45query_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "plp-store-filter": () => import("/opt/build/repo/domains/commerce/middleware/plpStoreFilter.ts")
}